/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { LegalBypassReason } from './';
import {
    LegalBypassReasonFromJSON,
    LegalBypassReasonFromJSONTyped,
    LegalBypassReasonToJSON,
} from './';
import type { UserReference } from './';
import {
    UserReferenceFromJSON,
    UserReferenceFromJSONTyped,
    UserReferenceToJSON,
} from './';

/**
 * 
 * @export
 * @interface FreelancerLegalBypassResource
 */
export interface FreelancerLegalBypassResource {
    /**
     * The client team ID
     * @type {string}
     * @memberof FreelancerLegalBypassResource
     */
    clientTeamId: string;
    /**
     * The client company name
     * @type {string}
     * @memberof FreelancerLegalBypassResource
     */
    clientCompanyName: string;
    /**
     * When the bypass was created
     * @type {Date}
     * @memberof FreelancerLegalBypassResource
     */
    creationDate: Date;
    /**
     * When the bypass expires
     * @type {Date}
     * @memberof FreelancerLegalBypassResource
     */
    endDate: Date;
    /**
     * 
     * @type {UserReference}
     * @memberof FreelancerLegalBypassResource
     */
    createdBy: UserReference;
    /**
     * 
     * @type {LegalBypassReason}
     * @memberof FreelancerLegalBypassResource
     */
    bypassReason: LegalBypassReason;
    /**
     * Comment provided when creating the bypass
     * @type {string}
     * @memberof FreelancerLegalBypassResource
     */
    bypassMessage: string;
    /**
     * Whether the bypass is currently active (not expired)
     * @type {boolean}
     * @memberof FreelancerLegalBypassResource
     */
    active: boolean;
}

/**
 * Check if a given object implements the FreelancerLegalBypassResource interface.
 */
export function instanceOfFreelancerLegalBypassResource(value: object): value is FreelancerLegalBypassResource {
    if (!('clientTeamId' in value) || value['clientTeamId'] === undefined) return false;
    if (!('clientCompanyName' in value) || value['clientCompanyName'] === undefined) return false;
    if (!('creationDate' in value) || value['creationDate'] === undefined) return false;
    if (!('endDate' in value) || value['endDate'] === undefined) return false;
    if (!('createdBy' in value) || value['createdBy'] === undefined) return false;
    if (!('bypassReason' in value) || value['bypassReason'] === undefined) return false;
    if (!('bypassMessage' in value) || value['bypassMessage'] === undefined) return false;
    if (!('active' in value) || value['active'] === undefined) return false;
    return true;
}

export function FreelancerLegalBypassResourceFromJSON(json: any): FreelancerLegalBypassResource {
    return FreelancerLegalBypassResourceFromJSONTyped(json, false);
}

export function FreelancerLegalBypassResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): FreelancerLegalBypassResource {
    if (json == null) {
        return json;
    }
    return {
        
        'clientTeamId': json['clientTeamId'],
        'clientCompanyName': json['clientCompanyName'],
        'creationDate': (new Date(json['creationDate'])),
        'endDate': (new Date(json['endDate'])),
        'createdBy': UserReferenceFromJSON(json['createdBy']),
        'bypassReason': LegalBypassReasonFromJSON(json['bypassReason']),
        'bypassMessage': json['bypassMessage'],
        'active': json['active'],
    };
}

export function FreelancerLegalBypassResourceToJSON(value?: FreelancerLegalBypassResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'clientTeamId': value['clientTeamId'],
        'clientCompanyName': value['clientCompanyName'],
        'creationDate': ((value['creationDate']).toISOString()),
        'endDate': ((value['endDate']).toISOString()),
        'createdBy': UserReferenceToJSON(value['createdBy']),
        'bypassReason': LegalBypassReasonToJSON(value['bypassReason']),
        'bypassMessage': value['bypassMessage'],
        'active': value['active'],
    };
}

